import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_LAST_PAYMENT } from '../../../utils/constants';

export default (paymentVar) => {
  return (newPayment) => {
    paymentVar(newPayment);
    setSessionStorageItem(SESSION_STORAGE_LAST_PAYMENT, newPayment);
  };
};
